import { defineComponent, ref, computed, toRef, resolveComponent, openBlock, createBlock, normalizeClass, withCtx, createElementVNode, mergeProps, withModifiers, renderSlot } from 'vue';
import { t as te } from '../OrAutocompleteV3-508d99c0.js';
import { OrPopoverV3 as script$1, PopoverPlacement } from '../or-popover-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-46210775.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';

const Menu = [
// Layout
'overflow-y-auto',
// Box
'min-w-[160px]', 'md:max-w-[256px]', 'max-h-[340px]'];

var script = defineComponent({
  name: 'OrMenu',
  components: {
    OrPopover: script$1
  },
  inheritAttrs: false,
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: Object,
      default: undefined
    },
    placement: {
      type: String,
      default: () => PopoverPlacement.Bottom
    },
    offset: {
      type: [Number, Object, Function],
      default: 8
    },
    // TODO: Remove after migration to Vue 3
    additionalStyles: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:state', 'open', 'close'],
  expose: ['root', 'state', 'open', 'close', 'toggle'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-menu-v3', ...Menu]);
    const popoverStyles = computed(() => ['or-menu-popover-v3']);
    // State
    const {
      state,
      open,
      close,
      toggle
    } = te(toRef(props, 'isOpen'), context.emit);
    // Handlers
    function onClick(event) {
      const path = event.composedPath();
      if (path.some(({
        classList
      }) => classList === null || classList === void 0 ? void 0 : classList.contains('or-menu-item-v3'))) {
        close();
      }
    }
    return {
      root,
      rootStyles,
      popoverStyles,
      state,
      open,
      close,
      toggle,
      onClick
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrPopover = resolveComponent("OrPopover");
  return openBlock(), createBlock(_component_OrPopover, {
    class: normalizeClass(_ctx.popoverStyles),
    "custom-styles": _ctx.popoverStyles,
    "is-open": _ctx.state === 'open',
    variant: 'auto',
    trigger: _ctx.trigger,
    placement: _ctx.placement,
    offset: _ctx.offset,
    "keep-alive": false,
    "onUpdate:state": _cache[1] || (_cache[1] = $event => $event === 'open' ? _ctx.open() : _ctx.close())
  }, {
    default: withCtx(() => [createElementVNode("div", mergeProps(_ctx.$attrs, {
      ref: 'root',
      class: [_ctx.rootStyles, ..._ctx.additionalStyles],
      onClick: _cache[0] || (_cache[0] = withModifiers($event => _ctx.onClick($event), ["stop"]))
    }), [renderSlot(_ctx.$slots, "default")], 16 /* FULL_PROPS */)]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class", "custom-styles", "is-open", "trigger", "placement", "offset"]);
}

script.render = render;
script.__file = "src/components/or-menu-v3/OrMenu.vue";

export { script as OrMenuV3 };
